module.exports = __webpack_public_path__ + "img/double-chevron-right.5a10da10.svg";